const formatPhone = ph => {
  if (!ph || typeof ph !== 'string') {
    return ph;
  }

  const raw = ph.replace(/\s|-/gi, '');
  const startsWith1 = raw.substring(0, 1) === '1';

  if (/^\d+$/.test(raw) && (raw.length <= 10 || raw.length <= 11 && startsWith1)) {
    const length = raw.length;
    const offsets = startsWith1 ? [1, 4, 7] : [0, 3, 6];
    return `${startsWith1 ? `1${length > 1 ? '-' : ''}` : ''}
      ${raw.substring(offsets[0], offsets[0] + 3)}${length > offsets[1] ? '-' : ''}
      ${raw.substring(offsets[1], offsets[1] + 3)}${length > offsets[2] ? '-' : ''}
      ${raw.substring(offsets[2])}`.replace(/\s/gi, '');
  }

  return ph;
};

export default formatPhone;